import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import titleMap from '../hooks/titleMap';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga4';

const RouteTitleSetter = ({ defaultTitle = "VE Cloud by Vechnology" }) => {
    const location = useLocation();

    const pathname = location.pathname;
    let title = titleMap[pathname];

    if(!title) {
        const match = Object.keys(titleMap).find(key => 
            pathname.startsWith(key)
        );
        title = titleMap[match];
    }

    const finalTitle = title ? `${title} | VE Cloud` : defaultTitle;

    useEffect(() => {
        document.title = finalTitle;
        ReactGA.send({
            hitType: "pageview",
            page: location.pathname + location.search,
            title: finalTitle,
        });
    }, [location, finalTitle]);

    return (
        <Helmet>
            <title>{finalTitle}</title>
        </Helmet>
    )
}

export default RouteTitleSetter;
